import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import {
  appLoadingSelector,
  determinateLoadingSelector,
} from "../reducers/ownApp/selectors";

import { CircularProgressWithLabel } from "./CircularProgressWithLabel";
import { depotLoadingSelector } from "../reducers/depot/selectors";
import { matrixProfileLoadingSelector } from "../reducers/matrixProfile/selectors";
import { driverManagementLoadingSelector } from "../reducers/driverManagement/selectors";
import { routeManagementLoadingSelector } from "../reducers/routeManagement/selectors";
import { sectionManagementLoadingSelector } from "../reducers/sectionManagement/selectors";
import { shiftManagerManagementLoadingSelector } from "../reducers/shiftManagerManagement/selectors";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 9997,
    color: "#fff",
  },
});

export const LoadingBackdrop = () => {
  const determinateLoading = useSelector(determinateLoadingSelector);
  const matrixProfileLoading = useSelector(matrixProfileLoadingSelector);
  const depotLoading = useSelector(depotLoadingSelector);
  const appLoading = useSelector(appLoadingSelector);
  const driverManagementLoading = useSelector(driverManagementLoadingSelector);
  const routeManagementLoading = useSelector(routeManagementLoadingSelector);
  const sectionManagementLoading = useSelector(
    sectionManagementLoadingSelector
  );
  const shiftManagerManagementLoading = useSelector(
    shiftManagerManagementLoadingSelector
  );
  const styles = useStyles();

  return (
    <Backdrop
      className={styles.backdrop}
      open={
        matrixProfileLoading ||
        depotLoading ||
        appLoading ||
        driverManagementLoading ||
        routeManagementLoading ||
        sectionManagementLoading ||
        shiftManagerManagementLoading
      }
    >
      {determinateLoading ? (
        <CircularProgressWithLabel
          color="inherit"
          value={determinateLoading.normalisedValue}
        />
      ) : (
        <CircularProgress color="inherit" />
      )}
    </Backdrop>
  );
};
